import React  from 'react';
import Classes from "classnames";
import UrlFieldProto from "./url-proto";

export default function renderUrlGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-url-group-list-header');

    const notSet = _.isNil(data.value);

    return (
        <div className={classes}>
            {!notSet && <UrlFieldProto renderMode="list" id={id} canEdit={false} value={data.value}/>}
            {notSet && <div className="group-list-header-value">Not set</div>}
        </div>
    );
}